
import { ReactNode, useState } from "react";
import { getAssetPath } from "@/utils/assetUtils";

type StepCardProps = {
  number: string;
  title: string;
  icon: ReactNode;
  description: string;
};

const StepCard = ({ number, title, icon, description }: StepCardProps) => {
  const [numberImageLoaded, setNumberImageLoaded] = useState(false);
  const [iconImageLoaded, setIconImageLoaded] = useState(false);
  
  // Map number to the correct image path
  const getNumberImage = (num: string) => {
    switch (num) {
      case "1":
        return getAssetPath("Landing_1.png");
      case "2":
        return getAssetPath("Landing_2.png");
      case "3":
        return getAssetPath("Landing_3.png");
      default:
        return "";
    }
  };
  
  // Map number to icon image path based on the step content
  const getIconImage = (num: string) => {
    switch (num) {
      case "1":
        return getAssetPath("landing_get_approved_icon.png");
      case "2":
        return getAssetPath("landing_earn_extra_icon.png");
      case "3":
        return getAssetPath("landing_complete_trips_icon.png");
      default:
        return "";
    }
  };

  return (
    <div className="bg-white rounded-3xl p-8 relative shadow-lg border border-gray-100 transition-all duration-500">
      <div className="flex flex-col space-y-6">
        {/* Number Image with Fallback */}
        <div>
          {!numberImageLoaded && (
            <div className="w-12 h-12 rounded-full bg-green-500 flex items-center justify-center text-2xl font-bold text-white">
              {number}
            </div>
          )}
          <img 
            src={getNumberImage(number)} 
            alt={`Step ${number}`} 
            className={`w-24 h-auto ${numberImageLoaded ? 'block' : 'hidden'}`}
            onLoad={() => setNumberImageLoaded(true)}
            onError={() => {
              console.error(`Failed to load step number image: ${number}`);
              // Keep fallback visible
            }}
          />
        </div>
        
        {/* Title */}
        <h3 className="text-2xl font-bold text-black">{title}</h3>
        
        {/* Icon and Description */}
        <div className="flex items-center gap-4">
          {/* Icon with Fallback */}
          <div className="flex-shrink-0">
            {!iconImageLoaded && (
              <div className="bg-black/5 w-12 h-12 rounded-full flex items-center justify-center">
                {icon}
              </div>
            )}
            <img 
              src={getIconImage(number)} 
              alt={`Icon for Step ${number}`} 
              className={`w-12 h-12 ${iconImageLoaded ? 'block' : 'hidden'}`}
              onLoad={() => setIconImageLoaded(true)}
              onError={() => {
                // Keep fallback visible
              }}
            />
          </div>
          
          <p className="text-lg text-gray-600">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default StepCard;
